export enum AnalyticsViewType {
  News = "news",
  Event = "event",
  Video = "video",
  HandballEvent = "hb_event",
}
